import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import AvoirCommandeCard from "./AvoirCommandeCard";
import AvoirCommandeSummary from "./AvoirCommandeSummary";

const AvoirCommande = ({ isParticulier, data, updateAvoir }) => {
  const { t } = useTranslation("common");
  const groupedPackings = useMemo(() => {
    if (!data?.attributes?.packings?.data) return [];

    const grouped = data.attributes.packings.data.reduce((acc, packing) => {
      const model =
        packing?.attributes?.model?.data?.id ||
        packing?.attributes?.name ||
        packing?.attributes?.reference;
      if (!model) return acc;

      const soldPrice = packing?.attributes?.soldPrice || 0;
      const discount =
        (packing?.attributes?.discount || 0) +
        (packing?.attributes?.globalDiscount || 0);
      const netPrice = soldPrice - discount;

      const key = `${model}_${netPrice}_${packing?.id}`;

      acc[key] = acc[key] || [];
      acc[key].push(packing);
      return acc;
    }, {});

    return Object.values(grouped);
  }, [data]);

  return (
    <div className="flex-grow-1">
      <p className="text-decoration-underline mb-4 text-dark f24">
        {t("Order")} {data?.attributes?.number}
      </p>
      <div className="d-flex flex-column gap-4">
        {groupedPackings?.map((group) => {
          return (
            <AvoirCommandeCard
              isParticulier={isParticulier}
              packings={group}
              quantity={group.length}
              updateAvoir={() => updateAvoir("packings", group, group.length)}
            />
          );
        })}
        {data?.attributes?.totalDeliveryHT > 0 && (
          <AvoirCommandeCard
            isParticulier={isParticulier}
            isDelivery
            deliveryPrice={
              isParticulier
                ? data?.attributes?.totalDeliveryTTC
                : data?.attributes?.totalDeliveryHT
            }
            updateAvoir={() =>
              updateAvoir(
                "delivery",
                isParticulier
                  ? data?.attributes?.totalDeliveryTTC
                  : data?.attributes?.totalDeliveryHT,
              )
            }
          />
        )}
        <AvoirCommandeSummary isParticulier={isParticulier} data={data} />
      </div>
    </div>
  );
};

export default AvoirCommande;
